// src/features/executive/insight/widgets/RevenueModeSelect.tsx
import { MenuItem, TextField } from '@mui/material'
import { useTranslation } from 'react-i18next'
import type { RevenueMode } from 'api/executive/executive.types'

interface Props {
  value: RevenueMode
  onChange: (value: RevenueMode) => void
}

// Bill-side first (fee, outstanding), then cash-flow (paid, paid_outstanding)
// — reads as "what was billed → what came in" left-to-right.
const OPTIONS: ReadonlyArray<{ value: RevenueMode; key: string }> = [
  { value: 'fee',              key: 'EXECUTIVE.INSIGHT.REVENUE_MODE.FEE' },
  { value: 'paid',             key: 'EXECUTIVE.INSIGHT.REVENUE_MODE.PAID' },
  { value: 'outstanding',      key: 'EXECUTIVE.INSIGHT.REVENUE_MODE.OUTSTANDING' },
  { value: 'paid_outstanding', key: 'EXECUTIVE.INSIGHT.REVENUE_MODE.PAID_OUTSTANDING' },
]

export default function RevenueModeSelect({ value, onChange }: Props) {
  const { t } = useTranslation()
  return (
    <TextField
      select
      size="small"
      value={value}
      onChange={(e) => onChange(e.target.value as RevenueMode)}
      sx={{
        minWidth: 140,
        '& .MuiInputBase-root': { fontSize: 13 },
        '& .MuiSelect-select': { py: 0.5 },
      }}
      SelectProps={{ MenuProps: { PaperProps: { sx: { maxHeight: 360 } } } }}
    >
      {OPTIONS.map((opt) => (
        <MenuItem key={opt.value} value={opt.value}>
          {t(opt.key)}
        </MenuItem>
      ))}
    </TextField>
  )
}
